if (!customElements.get('afd-offer-code')) {
  customElements.define('afd-offer-code', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      const button = this.querySelector('button');
      const status = this.querySelector('[role="status"]');
      button.addEventListener('click', async () => {
        clearTimeout(this.resetTimer);
        try {
          await navigator.clipboard.writeText(button.dataset.code);
          status.textContent = 'Copied!';
        } catch {
          status.textContent = 'Select to copy';
          const selection = window.getSelection();
          const range = document.createRange();
          range.selectNodeContents(button.querySelector('strong'));
          selection.removeAllRanges();
          selection.addRange(range);
        }
        this.resetTimer = setTimeout(() => { status.textContent = 'Copy'; }, 3000);
      });
    }
    disconnectedCallback() {
      clearTimeout(this.resetTimer);
    }
  });
}
